import {Injectable} from '@angular/core';
import {RealEstate} from '@ed-clients/shared';
import {HomeDynamic} from './home.interface';

@Injectable({providedIn: 'root'})
export class HomeDynamicMapperService {
  private static EMPTY_STRING = '';
  private static COVER_PLACEHOLDER_IMG = 'http://localhost:4200/assets/images/home/dwg-placeholder-pattern.png';

  public map(realEstate: RealEstate, btnText: string): HomeDynamic {
    return {
      title: realEstate.name || HomeDynamicMapperService.EMPTY_STRING,
      description: realEstate.description || HomeDynamicMapperService.EMPTY_STRING,
      buttonText: btnText || HomeDynamicMapperService.EMPTY_STRING,
      link: `/immobilien/${realEstate.id}` || HomeDynamicMapperService.EMPTY_STRING,
      markAsTopseller: realEstate.markAsTopseller || false,
      address: this.mapToHomeDynamicAddress(realEstate),
      baseRent: realEstate.customFields.ed_cf_real_estate_baseRent,
      livingSpaceInSquareMeters: realEstate.customFields.ed_cf_real_estate_livingSpaceInSquareMeters,
      currency: realEstate.customFields.ed_cf_real_estate_price_currency || HomeDynamicMapperService.EMPTY_STRING,
      realEstateType: realEstate.customFields.ed_cf_real_estate_type || HomeDynamicMapperService.EMPTY_STRING,
      numberOfRooms: realEstate.customFields.ed_cf_real_estate_number_of_rooms,
      cover: realEstate.cover?.media,
    };
  }

  private mapToHomeDynamicAddress(realEstate: RealEstate): {
    houseNumber: string,
    street: string,
    city: string,
    country: string
  } {
    return {
      houseNumber: realEstate.customFields.ed_cf_real_estate_title_houseNumber || HomeDynamicMapperService.EMPTY_STRING,
      street: realEstate.customFields.ed_cf_real_estate_street || HomeDynamicMapperService.EMPTY_STRING,
      city: realEstate.customFields.ed_cf_real_estate_city || HomeDynamicMapperService.EMPTY_STRING,
      country: realEstate.customFields.ed_cf_real_estate_country || HomeDynamicMapperService.EMPTY_STRING,
    };

  }
}
